module.exports = __webpack_public_path__ + "static/media/group_19.1c93b049.png";